import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ChangeDetectionStrategy,
  ViewChild,
} from "@angular/core";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { IPanelSettings } from "src/app/shared/interface/panel-settings";
import { IPictureData } from "../../shared/components/picture/picture.component";
import {
  AccordionItemState,
  IFAQImageItem,
} from "./components/faq-image-panel-item/faq-image-panel-item.component";
import { IRteStyleSettings } from '../../shared/interface/rte-style-settings';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';

interface IFaqImagePanelData {
  title?: IUProperty<string>;
  titleColor?: IUProperty<string>;
  description?: IUProperty<string>;
  image?: IUProperty<IPictureData>;
  items?: IUProperty<IFAQImageItem[]>;
  panelSettings?: IPanelSettings;

  titleStyleSettingsComposition?: ITitleStyleSettings;
  rteStyleSettingsComposition?: IRteStyleSettings;
}

@Component({
  selector: "app-faq-image-panel",
  templateUrl: "./faq-image-panel.component.html",
  styleUrls: ["./faq-image-panel.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqImagePanelComponent implements OnInit {
  @Input() data: IFaqImagePanelData;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;

  accordionItemState = AccordionItemState;
  ready = false;

  get isPanelHasImage() {
    return (
      this.data.image && this.data.image.value && this.data.image.value.src
    );
  }

  constructor(private hostRef: ElementRef) {}

  ngOnInit(): void {
    this.data.items.value.forEach((item, i) => {
      item.state = AccordionItemState.closed;
      item.id = i;
    });
  }

  ngAfterViewInit(): void {
    applyTitleSettings(this.data, this.titleEl);
    applyRteSettings(this.data, this.descriptionEl);
  }
}
